import React, { useMemo } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { styled } from 'linaria/react';

type MoreInfoCardGridProps = {
  className?: string;
  cardNumber?: number;
  cardPerRow: number;
  children: React.ReactNode;
};

export const StyledMoreInfoCardGrid = styled.div<MoreInfoCardGridProps>`
  display: grid;
  grid-template-columns: ${({ cardPerRow }: MoreInfoCardGridProps) => `repeat(${cardPerRow}, 1fr)`};
  width: 100%;

  @media (--from-tablet) {
    gap: 16px 24px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    width: 100%;
    row-gap: 8px;
  }
`;

const moreInfoCardGridMap: Record<number, string> = {
  3: css`
    @media (--from-desktop) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (--only-tablet) {
      :first-child {
        grid-column: 1 / 3;
      }
    }
  `,
  5: css`
    @media (--only-largeDesktop) {
      grid-template-columns: 1fr 163px 163px 1fr;
    }

    @media (--only-desktop) {
      grid-template-columns: 1fr 124px 124px 1fr;
    }

    @media (--from-desktop) {
      :nth-child(1),
      :nth-child(2),
      :nth-child(4) {
        grid-column: auto / span 2;
      }
    }

    @media (--only-tablet) {
      :first-child {
        grid-column: 1 / 3;
      }
    }
  `,
};

export const MoreInfoCardGrid: React.FC<MoreInfoCardGridProps> = ({
  cardNumber,
  cardPerRow,
  children,
  className,
}) => {
  const styles = useMemo(() => cn(className, cardNumber && moreInfoCardGridMap[cardNumber]), [
    className,
    cardNumber,
  ]);

  return (
    <StyledMoreInfoCardGrid className={styles} cardPerRow={cardPerRow}>
      {children}
    </StyledMoreInfoCardGrid>
  );
};
